/**
 * Joins class names, dropping falsy values. Kept dependency-free rather than
 * pulling in clsx/classnames for a one-line job.
 */
export function cx(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
